var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    className: "star",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m39.475 6.686-5.462-.832L31.572.683a1.175 1.175 0 0 0-2.146 0l-2.44 5.171-5.462.832a1.266 1.266 0 0 0-.662 2.133l3.951 4.023-.935 5.683a1.207 1.207 0 0 0 1.735 1.316l4.887-2.683 4.886 2.683a1.208 1.208 0 0 0 1.735-1.316l-.935-5.683 3.951-4.023a1.266 1.266 0 0 0-.662-2.133zm-5.215 5.5.886 5.406-4.646-2.551-4.647 2.55.886-5.406-3.761-3.827 5.2-.789L30.5 2.648l2.325 4.921 5.2.789-3.765 3.828z",
    transform: "translate(-20.5 .013)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8a04a1eb.svg";
export { ForwardRef as ReactComponent };